import React from 'react';
import { StyleSheet, View } from 'react-native';
import Button from '../Reusables/Button';
import { useTheme } from '../../theme';
import { fs, s, v } from '../../utils/libs';

interface ClearBasketActionsProps {
  onClear: () => void;
  onContinue: () => void;
}

/**
 * The "Clear Basket?" sheet's buttons, for its footer. Clear Basket is
 * outlined in red like every other button that clears the basket
 * (BasketConflictSheet); continuing keeps the green fill.
 */
const ClearBasketActions: React.FC<ClearBasketActionsProps> = ({
  onClear,
  onContinue,
}) => {
  const { theme } = useTheme();

  return (
    <View style={styles.actions}>
      <Button
        text="Clear Basket"
        // Same trash icon as removing an item on the Basket.
        icon="trash"
        iconSize={16}
        onPress={onClear}
        fullWidth
        height={v(48)}
        fontSize={fs(14)}
        borderRadius={s(8)}
        backgroundColor={theme.colors.surface}
        borderColor={theme.colors.errorDark}
        borderWidth={3}
        textColor={theme.colors.errorDark}
        rippleColor={theme.colors.errorSurface}
      />
      <Button
        text="No, Continue With Order"
        trailingIcon="arrow-right"
        iconSize={18}
        onPress={onContinue}
        fullWidth
        height={v(48)}
        fontSize={fs(14)}
        borderRadius={s(8)}
        backgroundColor={theme.colors.success}
        rippleColor={theme.colors.primary}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  actions: {
    gap: v(10),
    paddingTop: v(12),
    // The footer adds s(2) of side margin; together they match the content's s(20).
    paddingHorizontal: s(20) - s(2),
  },
});

export default ClearBasketActions;
